<template>
    <TableFilter :scheme-type="enumDef.filterSchemeType.SellerAllReceivablesRevolvingPutOptions"
                 :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
		<!-- Debtor -->
		<div class="filter_item">
			<div class="filter_head">{{this.$t("common.debtor")}}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="debtorName"
						ref="filter_debtorName"
			></TextFilter>
			<TextFilter :label-text="this.$t('common.riskScore')"
						  columnName="debtorCreditsafeRating"
						  ref="filter_debtorCreditsafeRating"
			></TextFilter>
			<IndustryFilter :label-text="this.$t('common.industry')"
							columnName="debtorIndustryNaceCode"
							ref="filter_debtorIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="this.$t('common.country')"
						   columnName="debtorCountry"
						   :company-type="enumDef.companyType.DebtorCompany"
						   ref="filter_debtorCountry"
			></CountryFilter>
		</div>
		<!-- Investor -->
		<div class="filter_item">
			<div class="filter_head">{{this.$t("common.investor")}}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="ownerCompanyName"
						ref="filter_ownerCompanyName"
			></TextFilter>
			<IndustryFilter :label-text="this.$t('common.industry')"
							columnName="sellerIndustryNaceCode"
							ref="filter_debtorIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="this.$t('common.country')"
						   columnName="sellerCountry"
						   ref="filter_debtorCountry"
			></CountryFilter>
		</div>
		<!-- Option -->
		<div>
			<div class="filter_head">{{$t("common.revolvingPutOption")}}</div>
			<div class="flex">
				<div class="filter_item">
					<EnumFilter :label-text="$t('common.status')"
								column-name="status"
								:enum-def="enumDef.revolvingPutOptionStatus"
								:exclude="(value) => enumDef.revolvingPutOptionStatus.isArchived(value) || enumDef.revolvingPutOptionStatus.isUnaccepted(value)"
								ref="filter_status"
					></EnumFilter>
					<TextFilter :label-text="$t('common.contractNumber')"
								column-name="referenceNumber"
								ref="filter_referenceNumber"
					></TextFilter>
					<DateFilter :label-text="$t('revolvingPutOption.optionStart')"
								column-name="startDate"
								ref="filter_startDate"
					></DateFilter>
					<DateFilter :label-text="$t('revolvingPutOption.optionEnd')"
								column-name="endDate"
								ref="filter_endDate"
					></DateFilter>
					<CurrencyFilter :label-text="$t('common.ccy')"
									column-name="currency"
									ref="filter_currency"
					></CurrencyFilter>
				</div>
				<div class="filter_item filter_item_xl">
					<FromToFilter :label-text="$t('revolvingPutOption.discount.withPercent')"
								  column-name="discountRate"
								  ref="filter_discountRate"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.premium.withPercent')"
								  column-name="premium"
								  ref="filter_premium"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.revolvingLine')"
								  column-name="saleLimit"
								  ref="filter_saleLimit"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.estimatedSalesVolume')"
								  column-name="estimatedSalesVolume"
								  ref="filter_estimatedSalesVolume"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.utilization')"
								  column-name="usedSaleLimitPercentage"
								  ref="filter_usedSaleLimitPercentage"
					></FromToFilter>
				</div>
			</div>
		</div>
    </TableFilter>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import IndustryFilter from "@/components/newFilter/IndustryFilter.vue";
import CountryFilter from "@/components/newFilter/CountryFilter";
import TableFilter from "@/components/newFilter/TableFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import EnumFilter from "@/components/newFilter/EnumFilter";
import CurrencyFilter from "@/components/newFilter/CurrencyFilter";

export default {
    components: {
		CurrencyFilter,
    	EnumFilter,
        TableFilter,
        CountryFilter,
        IndustryFilter,
        FromToFilter,
        TextFilter,
		DateFilter
    },
    data() {
        return {
            enumDef: enumDef,
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    }
};
</script>
